import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
  readonly openBooking$ = new Subject<string>();
  readonly openIntake$ = new Subject<string>();

  openBooking(bookingId: string) {
    this.openBooking$.next(bookingId);
  }

  openIntake(intakeId: string) {
    this.openIntake$.next(intakeId);
  }
}
